<!-- src/pages/ProfitCalculatorPage.vue -->
<template>
  <profit-calculator-app />
</template>

<script>
import ProfitCalculatorApp from '@/components/ProfitCalculator/ProfitCalculator.vue'

export default {
  name: 'ProfitCalculatorPage',
  components: {
    ProfitCalculatorApp
  }
}
</script>
